// componente per la visualizzazione dell'header; non contiene metodi particolari, ma permette di esportare la classe "HeaderComponent"
// con la sua pagina HTML ed il suo scss

import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
    constructor(
    ) {
    }

    ngOnInit() {
    }
}
